module.exports = __webpack_public_path__ + "dist/assets/techsee-light.1428779f1d45385305580d8759cbc625.png";